export default "__VITE_ASSET__DBT5a1eV__"